<template>
  <div class="header">
    <div class="container">
      <div class="header__logo">
        <div class="logo">
          <div class="logo__stars"></div>
        </div>
      </div>
      <h1 class="header__title">
        PRAWDZIWY PROGRAM<br>PLATFORMY OBYWATELSKIEJ
      </h1>
      <div class="header__date">
        <!-- <span class="header__date-day">26</span> -->
        <!-- <span class="header__date-vertical">Maja 2019</span> -->
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.logo {
  width: 170px;
  height: 170px;
  // background-image: url(/assets/images/svg/stars.svg);
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
  position: relative;
}
.logo__stars {
  height: 120px;
  background-image: url(/assets/images/svg/logo.svg);
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
  position: absolute;
  top: 35px;
  left: 0;
  right: 0;
}
.header {
  padding-top: 20px;
  > .container {
    padding: 0;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: space-around;
  }
}

.header__wrap {
  display: flex;
  align-items: center;
}

.header__title {
  font-family: "Anton", sans-serif;
  font-size: 45px;
  font-weight: normal;
  text-transform: uppercase;
  color: #fff;
  margin-left: 25px;
  line-height: 1.3;
  order: 3;
  width: 100%;
  text-align: center;
}

.header__logo {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  svg {
    position: absolute;
    top: auto;
    bottom: auto;
    left: 0;
  }
}

.header__date {
  position: relative;
  // margin: 0 auto;
  font-family: "Anton", sans-serif;
  order: 2;
  margin: 0;
}

.header__date-day {
  font-size: 140px;
  color: #fff;
}

.header__date-vertical {
  position: absolute;
  top: 60px;
  right: -50px;
  display: block;
  transform: rotate(90deg);
  color: #fff;
  font-size: 16.8px;
  text-transform: uppercase;
}

@media screen and (min-width: 480px) {
}

@media screen and (min-width: 970px) {
  .logo {
    width: 140px;
    height: 140px;
  }

  .logo__stars {
    height: 100px;
    top: 30px;
  }

  .header {
    padding-top: 20px;
    > .container {
      display: flex;
      flex-direction: row;
      align-items: center;
    }
  }

  .header__title {
    font-size: 38px;
    order: 2;
    width: auto;
    text-align: left;
  }

  .header__date-day {
    font-size: 120px;
  }
  .header__date {
    margin-right: auto;
    margin-left: 80px;
    order: 3;
  }
}

@media screen and (min-width: 1170px) {
  .logo {
    width: 180px;
    height: 180px;
  }

  .logo__stars {
    height: 130px;
  }

  .header__title {
    font-size: 50px;
  }

  .header__date-day {
    font-size: 140px;
  }
  .header__date {
    margin: 0 auto;
  }
}

@media screen and (min-width: 1452px) {
}
</style>
